import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AllUsers from "./views/components/AllUsers/AllUsers";
import UserMetricsPage from "./views/components/Reports/UserMetrics";
import MealPlan from "./views/components/MealPlan";
import Login from "./views/components/Login";
import Layout from "./Layout";
import ProtectedRoute from "./pages/ProtectedRoute";
import TrainerContextProvider, {
  trainerContextStore,
} from "./context/trainerContext/TrainerContextProvider";
import TrainersListing from "./views/components/Trainers/TrainersListing";
import PermissionsListing from "./views/components/Permissions/PermissionListing";
import AddPermission from "./views/components/Permissions/AddPermission";
import EditPermission from "./views/components/Permissions/EditPermission";
import RolesListing from "./views/components/Roles/RolesListing";
import AddRole from "./views/components/Roles/AddRole";
import EditRole from "./views/components/Roles/EditRole";
import EditTrainer from "./views/components/Trainers/EditTrainer";
import NotesListingPage from "./views/components/Notes";
import ReportListingPage from "./views/components/Reports/ReportListing";
import AddReportPage from "./views/components/Reports/AddReport";
import UpdateReportPage from "./views/components/Reports/EditReport";
import PrescriptionsListing from "./views/components/Prescriptions/PrescriptionsLisiting";
import AddPrescription from "./views/components/Prescriptions/AddPrescription";
import Profile from "./views/components/Profile/Profile";
import RingDetailsComponent from "./views/components/RingDetails";
import AnalysisPage from "./views/components/Analysis";
import TrainerSlotsListing from "./views/components/SlotManagement/TrainerSlots/Listing";
import { ToastContainer } from "react-toastify";
import TrainerSessionsListing from "./views/components/SlotManagement/TrainerSessions/Listing";
import UserSessionsListing from "./views/components/SlotManagement/UserSessions/Listing";
import { useEffect } from "react";
import Assessment from "./views/components/Assessment";
import AllCGMUsersComponent from "./views/components/CGMDetails/AllCGMUsers";
import CGMDetailsComponent from "./views/components/CGMDetails";

function App() {
  useEffect(() => {
    const data = localStorage.getItem("trainerData");

    if (data) {
      const parsedData = JSON.parse(data);
      trainerContextStore?.setTrainerState?.({ ...parsedData });
    }
  }, []);

  return (
    <TrainerContextProvider>
      <ToastContainer />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Layout />}>
            <Route path="/" element={<ProtectedRoute />}>
              <Route path="/" element={<AllUsers />} />

              <Route path="/profile" element={<Profile />} />

              <Route path="/users/:userId/">
                <Route path="reports" element={<ReportListingPage />} />
                <Route path="ring-details" element={<RingDetailsComponent />} />
                <Route path="cgm-details" element={<CGMDetailsComponent />} />
                <Route path="reports/add" element={<AddReportPage />} />
                <Route path="reports/metrics" element={<UserMetricsPage />} />
                <Route
                  path="reports/:reportId"
                  element={<UpdateReportPage />}
                />
                <Route path="meal-plan" element={<MealPlan />} />
                <Route path="meal-plan/analysis" element={<AnalysisPage />} />
                <Route
                  path="prescriptions"
                  element={<PrescriptionsListing />}
                />
                <Route path="prescriptions/add" element={<AddPrescription />} />
                <Route path="notes" element={<NotesListingPage />} />
                <Route path="sessions" element={<UserSessionsListing />} />
                <Route path="assessments" element={<Assessment />} />
              </Route>

              <Route path="/admin">
                <Route path="trainers" element={<TrainersListing />} />
                <Route path="cgm-users" element={<AllCGMUsersComponent />} />
                <Route path="trainers/:trainerId" element={<EditTrainer />} />
                <Route path="permissions" element={<PermissionsListing />} />
                <Route path="permissions/add" element={<AddPermission />} />
                <Route
                  path="permissions/:permissionId"
                  element={<EditPermission />}
                />
                <Route path="roles" element={<RolesListing />} />
                <Route path="roles/add" element={<AddRole />} />
                <Route path="roles/:roleId" element={<EditRole />} />
              </Route>

              <Route path="/trainers">
                <Route path="slots" element={<TrainerSlotsListing />} />
                <Route path="sessions" element={<TrainerSessionsListing />} />
              </Route>
            </Route>

            {/* <Route path="/dashboard" element={<Dashboard />} /> */}
            {/* <Route path="/newtask" element={<NewTask />} /> */}
          </Route>
        </Routes>
      </BrowserRouter>
    </TrainerContextProvider>
  );
}

export default App;
